import type { Attribute } from 'flow/store/engine/types';

/* prunes all archived service attributes */
export function getActiveAttributes(
  attributes: Record<string, Attribute>,
): Record<string, Attribute> {
  return Object.entries(attributes)
    .filter(([, attributeObj]) => !attributeObj.archivedAt)
    .reduce((acc, [attributeId, attributeObj]) => ({
      ...acc, [attributeId]: attributeObj,
    }), {});
}

/* sorts attributes by name into an attribute array */
export function sortAttributes(
  attributes: Record<string, Attribute>,
): Attribute[] {
  return Object.values(attributes)
    .sort((a, b) => (
      (a.display_name ?? '').localeCompare(b.display_name ?? '')
    ));
}
